/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
var DataContext = /*#__PURE__*/React.createContext({});
export default DataContext;